import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export interface ContentCSSProperties extends CSSProperties {
  '--height'?: string;
  '--overflow': string;
}

export interface ButtonCSSProperties extends CSSProperties {
  '--gradient'?: string;
}

const gradientHeight = 100;

export const content = css`
  height: var(--height);
  overflow: var(--overflow);
  position: relative;
`;

export const button = css`
  margin-top: ${spacing.base}px;
  ${responsiveText.BODY.MD};
  color: ${palette.blueBase};
  border: 0 none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: ${spacing.sm}px 0;
  column-gap: ${spacing.xs}px;
  font-weight: 600;
  position: relative;
  width: 100%;

  &.focus-visible:focus {
    border-radius: 4px;
  }

  &[aria-expanded='false']::before {
    content: '';
    position: absolute;
    top: -${gradientHeight + spacing.base}px;
    left: 0;
    right: 0;
    height: ${gradientHeight}px;
    background: linear-gradient(180deg, transparent 0%, var(--gradient) 100%);
    pointer-events: none;
  }

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${spacing.xs}px;
  }
`;
